import confetti from "canvas-confetti";

const REALLYFAN_COLORS = ["#FF6B35", "#7000FF", "#FF8FA3", "#FFD93D"];

export const fireConfetti = (intensity = "medium") => {
  const params = {
    light: { particleCount: 50, spread: 60, startVelocity: 25 },
    medium: { particleCount: 120, spread: 80, startVelocity: 35 },
    big: { particleCount: 220, spread: 120, startVelocity: 50, scalar: 1.2 },
  };
  const cfg = params[intensity] || params.medium;

  confetti({
    ...cfg,
    origin: { x: 0.5, y: 0.7 },
    colors: REALLYFAN_COLORS,
    zIndex: 9999,
    disableForReducedMotion: true,
  });
};

export const fireConfettiFromButton = (buttonElement, intensity = "medium") => {
  if (!buttonElement) {
    fireConfetti(intensity);
    return;
  }
  const rect = buttonElement.getBoundingClientRect();
  const x = (rect.left + rect.width / 2) / window.innerWidth;
  const y = (rect.top + rect.height / 2) / window.innerHeight;

  const params = {
    light: { particleCount: 40, spread: 55 },
    medium: { particleCount: 100, spread: 70 },
    big: { particleCount: 180, spread: 100 },
  };

  confetti({
    ...(params[intensity] || params.medium),
    origin: { x, y },
    colors: REALLYFAN_COLORS,
    zIndex: 9999,
    disableForReducedMotion: true,
  });
};

export const haptic = (duration = 50) => {
  if (typeof navigator !== "undefined" && navigator.vibrate) {
    try {
      navigator.vibrate(duration);
    } catch {}
  }
};
